import { Link } from "react-router-dom";
import { Icon } from "./icons";
import { STATUS_LABEL, SUITE, moduleHref } from "./suite";
import { BcLink } from "./SuiteGrid";
import type { Anchor, ModelNode } from "./models";

export function NodeChip({ n }: { n: ModelNode }) {
  const planned = n.side === "courage" && n.status && n.status !== "live";
  const inner = (
    <>
      {n.side === "bc" ? <span className="tag bc">BC</span> : <span className="tag cm" aria-hidden="true" />}
      <span className="nm">{n.name}</span>
      {planned && <span className="st">{STATUS_LABEL[n.status!]}</span>}
      {n.side === "bc" && <Icon name="ext" size={12} />}
    </>
  );
  if (n.bc) return <BcLink p={{ name: n.name, page: n.bc }} className={`node ${n.side}`}>{inner}</BcLink>;
  const mod = n.app ? SUITE.flatMap((x) => x.modules).find((m) => m.id === n.app) : undefined;
  const to = n.to ?? (mod ? moduleHref(mod) : undefined);
  return to ? <Link to={to} className={`node ${n.side} ${planned ? "planned" : ""}`}>{inner}</Link> : <span className={`node ${n.side}`}>{inner}</span>;
}


const GROUPS: { key: "related" | "active" | "history"; name: string; hint: string }[] = [
  { key: "related", name: "Related records", hint: "Reference records that rarely change" },
  { key: "active", name: "Active", hint: "Open work in flight" },
  { key: "history", name: "History", hint: "Closed and posted" },
];

/** A main record and its related records, in three groups: related, active, history. */
export function AnchorCard({ a, compact = false }: { a: Anchor; compact?: boolean }) {
  return (
    <div className="dash-card anchor-card">
      {!compact && (
        <div className="anchor-h">
          <NodeChip n={a.node} />
          {a.node.note && <span className="muted">{a.node.note}</span>}
        </div>
      )}
      <div className="anchor-groups">
        {GROUPS.map((g) => (
          <div key={g.key} className={`anchor-group ${g.key}`}>
            <div className="ag-h"><span className="ag-dot" />{g.name}</div>
            <div className="dash-cap">{g.hint}</div>
            <ul>
              {a[g.key].map((n) => <li key={n.name}><NodeChip n={n} /></li>)}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
